import React, { useContext } from "react";
import styled from "styled-components";
import { ThemeContext } from "styled-components";

const Title = styled.h2`
  color: #181818;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 12px auto 8px auto;
`;

const Container = styled.div`
  background: ${(props) => props.theme.chat.headerBackground};
  border-radius: ${(props) =>
    props.currentTheme === "AVATAR" ? "16px" : "0px"};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 136px;
  margin-bottom: 38px;
  position: sticky;
  top: 16px;
  z-index: 10;
  h2 {
    color: #333;
    font-size: 1.25rem;
    font-weight: 500;
    margin: 10px auto 10px auto;
  }
`;

const MacroContainer = styled.div`
  display: flex;
`;

const Macro = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 12px;
  p {
    font-weight: 600;
    margin: 0;
    padding-top: 16px;
  }
  h3 {
    font-size: 42px;
    font-weight: 800;
    height: 42px;
    line-height: 42px;
    margin: 0;
    padding-left: 8px;
  }
  span {
    font-size: 1.75rem;
  }
`;

const CalFiber = styled.div`
  padding: 0px 12px;
  > div {
    display: flex;
    align-items: center;
  }
  p {
    width: 80px;
  }
  span {
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const MacrosDisplay = ({ protein, carbs, fat, calories, fiber }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <Title>Total Macros</Title>
      <Container currentTheme={theme.name}>
        <MacroContainer>
          <Macro>
            <p
              style={{ color: theme.name === "AVATAR" ? "#00ee46" : "#31bfff" }}
            >
              Protein
            </p>
            <h3>
              {protein}
              <span>g</span>
            </h3>
          </Macro>
          <Macro>
            <p
              style={{ color: "#31bfff" }}
            >
              Carbs
            </p>
            <h3>
              {carbs}
              <span>g</span>
            </h3>
          </Macro>
          <Macro>
            <p
              style={{ color: theme.name === "AVATAR" ? "#de37ff" : "#31bfff" }}
            >
              Fat
            </p>
            <h3>
              {fat}
              <span>g</span>
            </h3>
          </Macro>
        </MacroContainer>
        <CalFiber>
          <div>
            <p>Calories</p>
            <span>{calories}</span>
          </div>
          <div>
            <p>Fiber</p>
            <span>{fiber}g</span>
          </div>
        </CalFiber>
      </Container>
    </>
  );
};
